var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.047 7.262h-9.109l-2.865-3.13a.407.407 0 00-.3-.132h-3.82A1.955 1.955 0 002 5.953V18.52c0 .224.182-.407.407-.407.225 0 .704.631.704.407V5.953c0-.628.176-.842.804-.842h3.64l1.667 1.667s.96 1.11 1.386 1.517h9.44c.627 0 .84.292.84.92v9.306c0 .627-.213 1.035-.84 1.035H3.952c-.628 0-.842-.408-.842-1.035 0-.225-.48-.407-.704-.407A.407.407 0 002 18.52c0 1.076.876 1.952 1.953 1.952h16.094A1.955 1.955 0 0022 18.521V9.215a1.955 1.955 0 00-1.953-1.953z",
    fill: "var(--color-secondary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder-icon.3252610cfb4dd7657658adfe2a4fe07a.svg";
export { ForwardRef as ReactComponent };